import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {MDCFormField} from '@material/form-field';
import {MDCRadio} from '@material/radio';
import { HomeService } from 'src/app/core/http/web/home.service';
import { Router, ActivatedRoute } from '@angular/router';
import { GtmService } from 'src/app/core/services/utilities/gtm.service';
import { environment as params, environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav-widget-mobile',
  templateUrl: './nav-widget-mobile.component.html',
  styleUrls: ['./nav-widget-mobile.component.scss']
})
export class NavWidgetMobileComponent implements OnInit {

  urlBase: any = (<any>params).api.s3;
  @Input() public isMobile: boolean;
  @Input('widgetData') public widgetData: any;
  //@Input() public route: string;
  @Input('route') public route: string;
  public flightForm;
  event: any;
  public href: string = "";

  constructor(
  	private homeService: HomeService,
    private fb: FormBuilder,
    private router: Router,
    private _gtm: GtmService,
    private routy: ActivatedRoute) {

	  	this.getWidgetOptions();
	    this.flightForm = this.fb.group({
	      type_flight: ['redondo'],
	    });
	    this.routy.queryParams.subscribe(res => console.log('hay algooo', res))
    }

  ngOnInit() {
    this.href = this.router.url;
    
    this.getTabsData()
  }

  changeForm(value) {
    this.sendEvent(value);
    // this.showForm = value;
    this.event = value
    this.router.navigate([value]);
    console.log('this,evento', this.event)
  }

  sendEvent(event) {
    this._gtm.sendEvent(event);
  }

  getWidgetOptions() {
    this.homeService.getWidgetOptions().subscribe(
      data => {
        this.widgetData = data;
        if (
          !(
            data &&
            data.widget_motor &&
            data.widget_motor_hoteles &&
            data.widget_motor_tours &&
            data.widget_motor_vuelo_hotel &&
            data.widget_motor_vuelos &&
            JSON.stringify(data.widget_motor).length > 3 &&
            JSON.stringify(data.widget_motor_hoteles).length > 3 &&
            JSON.stringify(data.widget_motor_tours).length > 3 &&
            JSON.stringify(data.widget_motor_vuelo_hotel).length > 3 &&
            JSON.stringify(data.widget_motor_vuelos).length > 3
          )
        ) {
          console.warn('Sin data widgets');
        }
      },
      err => {
        console.error(err);
      }
    );
  }
  getTabsData() {


    const activeTab = document.getElementById('pills-vuelos-tab-mobile')
    const activeForm = document.getElementById('pills-vuelos-mobile')

    switch(this.href){
      case '/seguros':
        const segurosTab = document.getElementById('pills-seguros-tab-mobile')
        const formseguro = document.getElementById('pills-seguros-mobile')
        segurosTab.classList.add('active')
        formseguro.classList.add('active', 'show')
        activeTab.classList.remove('active')
        activeForm.classList.remove('active', 'show')
        break;
      case '/tours':
        const toursTab = document.getElementById('pills-tours-tab-mobile')
        const formTours = document.getElementById('pills-tours-mobile')
        toursTab.classList.add('active')
        formTours.classList.add('active', 'show')
        activeTab.classList.remove('active')
        activeForm.classList.remove('active', 'show')
        break;
      case '/paquetes':
        const paqTab = document.getElementById('pills-vuelohotel-tab-mobile')
        const formPaq = document.getElementById('pills-vuelohotel-mobile')
        paqTab.classList.add('active')
        formPaq.classList.add('active', 'show')
        activeTab.classList.remove('active')
        activeForm.classList.remove('active', 'show')
        break;
      case '/hoteles':
        const hotelTab = document.getElementById('pills-hoteles-tab-mobile')
        const formHotel = document.getElementById('pills-hoteles-mobile')
        hotelTab.classList.add('active')
        formHotel.classList.add('active', 'show')
        activeTab.classList.remove('active')
        activeForm.classList.remove('active', 'show')
        break;
    }
  }

}
